import React from 'react';

export default function ReminderPrompt({
  visible,
  busy,
  error,
  onEnable,
  onDismiss,
}) {
  if (!visible) return null;

  return (
    <div className="chat-reminder-prompt" role="region" aria-label="Reminder preferences">
      <div className="chat-reminder-prompt-copy">
        <strong>Continue later?</strong>
        <span>
          We’ll let you know when there’s something new here, even when the chat is closed.
        </span>
      </div>
      <div className="chat-reminder-prompt-actions">
        <button
          type="button"
          className="chat-reminder-prompt-primary"
          onClick={onEnable}
          disabled={busy}
        >
          {busy ? 'Enabling…' : 'Enable reminders'}
        </button>
        <button
          type="button"
          className="chat-reminder-prompt-secondary"
          onClick={onDismiss}
          disabled={busy}
        >
          Not now
        </button>
      </div>
      {error ? <p className="chat-reminder-prompt-error">{error}</p> : null}
    </div>
  );
}
